// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat_assistant_bot .expand_btn[data-v-3e3ee8cc] {
  width: 60px;
  height: 60px;
  background: #fff;
  transition: width 0.3s ease-in-out;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  border-radius: 15px;
  cursor: pointer;
  position: fixed;
  bottom: 120px;
  right: 10px;
  text-align: center;
  z-index: 99;
}
.chat_assistant_bot .expand_btn .assistance_box[data-v-3e3ee8cc] {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.chat_assistant_bot .expand_btn .assistance_box img[data-v-3e3ee8cc] {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  height: 45px;
}
.chat_assistant_bot .expand_btn .assistance_box img[data-v-3e3ee8cc]:hover {
  transform: rotate(360deg);
  transition: transform 1s ease;
}
.chat_assistant_bot .expand_btn .assistance_box p[data-v-3e3ee8cc] {
  font-size: 12px;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
  color: #000;
}
.chat_assistant_bot .expand_btn.position-left-alignment[data-v-3e3ee8cc] {
  left: 20px;
}
.chat_assistant_bot .assistant_header img[data-v-3e3ee8cc] {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  height: 45px;
}
.chat_assistant_bot .assistant_header img[data-v-3e3ee8cc]:hover {
  transform: rotate(360deg);
  transition: transform 1s ease;
}
.chat_assistant_bot .content[data-v-3e3ee8cc] {
  position: fixed;
  bottom: 10%;
  width: calc(100% - 20px);
  background: #fff;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  cursor: pointer;
  z-index: 999;
}
.chat_assistant_bot .content h6[data-v-3e3ee8cc] {
  margin: 0;
  white-space: nowrap;
  font-weight: bold;
  font-size: 1.1rem;
  color: #000;
  letter-spacing: -1px;
}
.chat_assistant_bot .content .chips__btn[data-v-3e3ee8cc] {
  background: rgba(255, 255, 255, 0.1);
  font-size: 13px;
  border-radius: 30px;
}
.chat_assistant_bot .content .chips__btn[data-v-3e3ee8cc]:hover {
  background: rgba(255, 255, 255, 0.15);
  transition: 0.5s;
  box-shadow: none !important;
}
.chat_assistant_bot .content .chips__btn[data-v-3e3ee8cc]:active {
  box-shadow: none;
  outline: none;
}
.chat_assistant_bot .br-15[data-v-3e3ee8cc] {
  border-radius: 15px;
}
.chat_assistant_bot .text-white-opacity[data-v-3e3ee8cc] {
  color: #ffffffcc;
}
.chat_assistant_bot .animate-fade[data-v-3e3ee8cc] {
  animation: fadeIn-3e3ee8cc 0.8s;
}
.chat_assistant_bot .assistant_close_icon[data-v-3e3ee8cc] {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat_assistant_bot .assistant_close_icon em[data-v-3e3ee8cc] {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  display: block;
  color: #0000005c;
  cursor: pointer;
  font-size: 12px !important;
}
.chat_assistant_bot .assistant_close_icon em[data-v-3e3ee8cc]:hover {
  transform: rotate(360deg);
  transition: transform 1s ease;
}
.chat_assistant_bot .animated_icon[data-v-3e3ee8cc] {
  animation: rotate-3e3ee8cc 550ms ease;
}
.chat_assistant_bot .py-c-3[data-v-3e3ee8cc] {
  padding: 1rem 0;
}
.chat_assistant_bot .services_options_container p[data-v-3e3ee8cc] {
  font-size: 14px;
}
@keyframes fadeIn-3e3ee8cc {
0% {
    transform: translateY(350px);
    opacity: 0;
}
100% {
    transform: translateY(0);
    opacity: 1;
}
}
@keyframes rotate-3e3ee8cc {
0% {
    transform: rotate(-360deg);
    transition: transform 550ms ease;
}
100% {
    transform: rotate(360deg);
    transition: transform 550ms ease;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/ChatAssistant/AssistantMobileIcon.vue","webpack://./AssistantMobileIcon.vue"],"names":[],"mappings":"AACA;EAEI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;ACDJ;ADbA;EAiBM,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ACDN;ADpBA;EAwBQ,0BAAA;EACA,6BAAA;EACA,YAAA;ACDR;ADGQ;EACE,yBAAA;EACA,6BAAA;ACDV;AD7BA;EAmCQ,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;ACHR;ADOI;EACE,UAAA;ACLN;ADtCA;EAgDI,0BAAA;EACA,6BAAA;EACA,YAAA;ACPJ;ADSI;EACE,yBAAA;EACA,6BAAA;ACPN;AD/CA;EA2DI,eAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,eAAA;EACA,YAAA;ACTJ;AD7DA;EAyEM,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;ACTN;ADrEA;EAkFM,oCAAA;EACA,eAAA;EACA,mBAAA;ACVN;ADYM;EACE,qCAAA;EACA,gBAAA;EACA,2BAAA;ACVR;ADaM;EACE,gBAAA;EACA,aAAA;ACXR;ADnFA;EAoGI,mBAAA;ACdJ;ADtFA;EAwGI,gBAAA;ACfJ;ADzFA;EA4GI,+BAAA;AChBJ;AD5FA;EAgHI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACjBJ;ADvGA;EA2HM,0BAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;ACjBN;ADmBM;EACE,yBAAA;EACA,6BAAA;ACjBR;ADnHA;EA0II,qCAAA;ACpBJ;ADtHA;EA8II,eAAA;ACrBJ;ADzHA;EAmJM,eAAA;ACvBN;AD2BE;AACE;IACE,4BAAA;IACA,UAAA;ACzBJ;AD4BE;IACE,wBAAA;IACA,UAAA;AC1BJ;AACF;AD6BE;AACE;IACE,0BAAA;IACA,gCAAA;AC3BJ;AD8BE;IACE,yBAAA;IACA,gCAAA;AC5BJ;AACF","sourcesContent":["\n.chat_assistant_bot {\n  .expand_btn {\n    width: 60px;\n    height: 60px;\n    background: #fff;\n    transition: width 0.3s ease-in-out;\n    overflow: hidden;\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n    border-radius: 15px;\n    cursor: pointer;\n    position: fixed;\n    bottom: 120px;\n    right: 10px;\n    text-align: center;\n    z-index: 99;\n\n    .assistance_box {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        transform: rotate(-360deg);\n        transition: transform 1s ease;\n        height: 45px;\n\n        &:hover {\n          transform: rotate(360deg);\n          transition: transform 1s ease;\n        }\n      }\n\n      p {\n        font-size: 12px;\n        margin-bottom: 10px;\n        letter-spacing: -0.5px;\n        color: #000;\n      }\n    }\n\n    &.position-left-alignment {\n      left: 20px;\n    }\n  }\n\n  .assistant_header img {\n    transform: rotate(-360deg);\n    transition: transform 1s ease;\n    height: 45px;\n\n    &:hover {\n      transform: rotate(360deg);\n      transition: transform 1s ease;\n    }\n  }\n\n  .content {\n    position: fixed;\n    bottom: 10%;\n    width: calc(100% - 20px);\n    background: #fff;\n    left: 0;\n    right: 0;\n    margin: auto;\n    text-align: center;\n    border-radius: 15px;\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n    cursor: pointer;\n    z-index: 999;\n\n    h6 {\n      margin: 0;\n      white-space: nowrap;\n      font-weight: bold;\n      font-size: 1.1rem;\n      color: #000;\n      letter-spacing: -1px;\n    }\n\n    .chips__btn {\n      background: rgba(255, 255, 255, 0.1);\n      font-size: 13px;\n      border-radius: 30px;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.15);\n        transition: 0.5s;\n        box-shadow: none !important;\n      }\n\n      &:active {\n        box-shadow: none;\n        outline: none;\n      }\n    }\n  }\n\n  .br-15 {\n    border-radius: 15px;\n  }\n\n  .text-white-opacity {\n    color: #ffffffcc;\n  }\n\n  .animate-fade {\n    animation: fadeIn 0.8s;\n  }\n\n  .assistant_close_icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n    font-size: 12px;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    em {\n      transform: rotate(-360deg);\n      transition: transform 1s ease;\n      display: block;\n      color: #0000005c;\n      cursor: pointer;\n      font-size: 12px !important;\n\n      &:hover {\n        transform: rotate(360deg);\n        transition: transform 1s ease;\n      }\n    }\n  }\n\n  .animated_icon {\n    animation: rotate 550ms ease;\n  }\n\n  .py-c-3 {\n    padding: 1rem 0;\n  }\n\n  .services_options_container {\n    p {\n      font-size: 14px;\n    }\n  }\n\n  @keyframes fadeIn {\n    0% {\n      transform: translateY(350px);\n      opacity: 0;\n    }\n\n    100% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(-360deg);\n      transition: transform 550ms ease;\n    }\n\n    100% {\n      transform: rotate(360deg);\n      transition: transform 550ms ease;\n    }\n  }\n}\n",".chat_assistant_bot .expand_btn {\n  width: 60px;\n  height: 60px;\n  background: #fff;\n  transition: width 0.3s ease-in-out;\n  overflow: hidden;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n  border-radius: 15px;\n  cursor: pointer;\n  position: fixed;\n  bottom: 120px;\n  right: 10px;\n  text-align: center;\n  z-index: 99;\n}\n.chat_assistant_bot .expand_btn .assistance_box {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.chat_assistant_bot .expand_btn .assistance_box img {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  height: 45px;\n}\n.chat_assistant_bot .expand_btn .assistance_box img:hover {\n  transform: rotate(360deg);\n  transition: transform 1s ease;\n}\n.chat_assistant_bot .expand_btn .assistance_box p {\n  font-size: 12px;\n  margin-bottom: 10px;\n  letter-spacing: -0.5px;\n  color: #000;\n}\n.chat_assistant_bot .expand_btn.position-left-alignment {\n  left: 20px;\n}\n.chat_assistant_bot .assistant_header img {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  height: 45px;\n}\n.chat_assistant_bot .assistant_header img:hover {\n  transform: rotate(360deg);\n  transition: transform 1s ease;\n}\n.chat_assistant_bot .content {\n  position: fixed;\n  bottom: 10%;\n  width: calc(100% - 20px);\n  background: #fff;\n  left: 0;\n  right: 0;\n  margin: auto;\n  text-align: center;\n  border-radius: 15px;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n  cursor: pointer;\n  z-index: 999;\n}\n.chat_assistant_bot .content h6 {\n  margin: 0;\n  white-space: nowrap;\n  font-weight: bold;\n  font-size: 1.1rem;\n  color: #000;\n  letter-spacing: -1px;\n}\n.chat_assistant_bot .content .chips__btn {\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 13px;\n  border-radius: 30px;\n}\n.chat_assistant_bot .content .chips__btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transition: 0.5s;\n  box-shadow: none !important;\n}\n.chat_assistant_bot .content .chips__btn:active {\n  box-shadow: none;\n  outline: none;\n}\n.chat_assistant_bot .br-15 {\n  border-radius: 15px;\n}\n.chat_assistant_bot .text-white-opacity {\n  color: #ffffffcc;\n}\n.chat_assistant_bot .animate-fade {\n  animation: fadeIn 0.8s;\n}\n.chat_assistant_bot .assistant_close_icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 12px;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.chat_assistant_bot .assistant_close_icon em {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  display: block;\n  color: #0000005c;\n  cursor: pointer;\n  font-size: 12px !important;\n}\n.chat_assistant_bot .assistant_close_icon em:hover {\n  transform: rotate(360deg);\n  transition: transform 1s ease;\n}\n.chat_assistant_bot .animated_icon {\n  animation: rotate 550ms ease;\n}\n.chat_assistant_bot .py-c-3 {\n  padding: 1rem 0;\n}\n.chat_assistant_bot .services_options_container p {\n  font-size: 14px;\n}\n@keyframes fadeIn {\n  0% {\n    transform: translateY(350px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes rotate {\n  0% {\n    transform: rotate(-360deg);\n    transition: transform 550ms ease;\n  }\n  100% {\n    transform: rotate(360deg);\n    transition: transform 550ms ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
